import { render, staticRenderFns } from "./app-message-box.vue?vue&type=template&id=2ece58e4&scoped=true&"
import script from "./app-message-box.vue?vue&type=script&lang=js&"
export * from "./app-message-box.vue?vue&type=script&lang=js&"
import style0 from "./app-message-box.vue?vue&type=style&index=0&id=2ece58e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ece58e4",
  null
  
)

export default component.exports